module.exports = `${require.publicPath}banner-img01.3a7c9432.png`;